export const CALENDAR_MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

export function getCalendarYears(fromYear = 1900, toYear = 2100): number[] {
  if (toYear < fromYear) return [];
  return Array.from({ length: toYear - fromYear + 1 }, (_, i) => fromYear + i);
}
